module.exports = __webpack_public_path__ + "static/media/text_box03.b7050f8b.png";